/**
 * Sütun sırası state'i - DataTable taşınabilir sütunlar için.
 * Sayfa yenilenince sıfırlanır (kalıcı değil).
 */
import { useState, useEffect } from "react";

export function useColumnOrder(columns) {
  const [columnOrder, setColumnOrder] = useState([]);

  useEffect(() => {
    const accessors = (columns || []).map((c) => c.accessor);
    setColumnOrder((prev) => {
      const kept = prev.filter((acc) => accessors.includes(acc));
      const added = accessors.filter((acc) => !prev.includes(acc));
      return kept.length > 0 ? [...kept, ...added] : accessors;
    });
  }, [columns]);

  return [columnOrder, setColumnOrder];
}
